(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-hd-comparison-table]';
    var READY_ATTR = 'data-hd-ct-ready';
    var MOBILE_QUERY = '(max-width: 767px)';
    var CLEAR_DELAY = 400;

    function closestGroup(node) {
        while (node && node.nodeType === 1) {
            if (node.hasAttribute && node.hasAttribute('data-hd-ct-group')) { return node; }
            node = node.parentNode;
        }
        return null;
    }

    function HdComparisonTable(root) {
        this.root = root;
        this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-hd-ct-group]'));

        if (!this.groups.length) { return; }

        this.mq = window.matchMedia(MOBILE_QUERY);
        this.wasMobile = this.mq.matches;

        this.bind();

        this.root.setAttribute(READY_ATTR, 'true');
        this.syncViewport();
    }

    HdComparisonTable.prototype.isMobile = function () {
        return this.mq.matches;
    };

    HdComparisonTable.prototype.panelOf = function (group) {
        return group.querySelector('[data-hd-ct-panel]');
    };

    HdComparisonTable.prototype.triggerOf = function (group) {
        return group.querySelector('[data-hd-ct-trigger]');
    };

    HdComparisonTable.prototype.scheduleClear = function (panel) {
        if (panel.hdCtTimer) { clearTimeout(panel.hdCtTimer); }

        panel.hdCtTimer = setTimeout(function () {
            panel.hdCtTimer = null;
            panel.style.height = '';
        }, CLEAR_DELAY);
    };

    HdComparisonTable.prototype.setOpen = function (group, open, animate) {
        var panel = this.panelOf(group);
        var trigger = this.triggerOf(group);

        if (!panel) { return; }

        if (animate === false || !this.isMobile()) {
            if (panel.hdCtTimer) { clearTimeout(panel.hdCtTimer); panel.hdCtTimer = null; }
            group.classList.toggle('is-open', open);
            if (trigger) { trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); }
            panel.style.height = '';
            return;
        }

        if (group.classList.contains('is-open') === open) { return; }

        var from = panel.getBoundingClientRect().height;
        var to = open ? panel.scrollHeight : 0;

        group.classList.toggle('is-open', open);
        if (trigger) { trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); }

        panel.style.height = from + 'px';
        void panel.offsetHeight;
        panel.style.height = to + 'px';

        this.scheduleClear(panel);
    };

    HdComparisonTable.prototype.openOnly = function (group, animate) {
        var self = this;

        this.groups.forEach(function (other) {
            self.setOpen(other, other === group, animate);
        });
    };

    HdComparisonTable.prototype.toggle = function (group) {
        if (group.classList.contains('is-open')) {
            this.setOpen(group, false);
        } else {
            this.openOnly(group);
        }
    };

    HdComparisonTable.prototype.syncViewport = function () {
        var self = this;
        var mobile = this.isMobile();

        if (!mobile) {
            this.groups.forEach(function (group) {
                var panel = self.panelOf(group);
                var trigger = self.triggerOf(group);

                if (panel) {
                    if (panel.hdCtTimer) { clearTimeout(panel.hdCtTimer); panel.hdCtTimer = null; }
                    panel.style.height = '';
                }
                if (trigger) { trigger.setAttribute('aria-expanded', 'true'); }
            });
            this.wasMobile = false;
            return;
        }

        var opened = null;
        this.groups.forEach(function (group) {
            if (!opened && group.classList.contains('is-open')) { opened = group; }
        });

        this.openOnly(opened || this.groups[0], false);
        this.wasMobile = true;
    };

    HdComparisonTable.prototype.bind = function () {
        var self = this;

        this.onClick = function (event) {
            var trigger = event.target.closest
                ? event.target.closest('[data-hd-ct-trigger]')
                : null;

            if (!trigger || !self.root.contains(trigger)) { return; }
            if (!self.isMobile()) { return; }

            event.preventDefault();
            self.toggle(closestGroup(trigger));
        };

        this.onViewportChange = function () {
            if (self.resizeT) { clearTimeout(self.resizeT); }
            self.resizeT = setTimeout(function () {
                if (self.isMobile() !== self.wasMobile) { self.syncViewport(); }
            }, 150);
        };

        this.root.addEventListener('click', this.onClick);
        window.addEventListener('resize', this.onViewportChange);

        if (this.mq.addEventListener) { this.mq.addEventListener('change', this.onViewportChange); }
        else if (this.mq.addListener) { this.mq.addListener(this.onViewportChange); }
    };

    HdComparisonTable.prototype.destroy = function () {
        var self = this;

        if (!this.groups || !this.groups.length) { return; }

        this.root.removeEventListener('click', this.onClick);
        window.removeEventListener('resize', this.onViewportChange);

        if (this.mq.removeEventListener) { this.mq.removeEventListener('change', this.onViewportChange); }
        else if (this.mq.removeListener) { this.mq.removeListener(this.onViewportChange); }

        if (this.resizeT) { clearTimeout(this.resizeT); }

        this.groups.forEach(function (group) {
            var panel = self.panelOf(group);
            if (panel && panel.hdCtTimer) { clearTimeout(panel.hdCtTimer); panel.hdCtTimer = null; }
        });

        this.root.removeAttribute(READY_ATTR);
    };

    function init(context) {
        var scope = context && context.querySelectorAll ? context : document;
        var roots = scope.querySelectorAll(ROOT_SELECTOR);

        for (var i = 0; i < roots.length; i++) {
            if (roots[i].hdComparisonTable) { continue; }
            roots[i].hdComparisonTable = new HdComparisonTable(roots[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
        init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        init(event.target || document);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        var target = event.target;
        if (!target || !target.querySelectorAll) { return; }

        var roots = target.querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots.length; i++) {
            if (roots[i].hdComparisonTable && roots[i].hdComparisonTable.destroy) {
                roots[i].hdComparisonTable.destroy();
            }
            roots[i].hdComparisonTable = null;
        }
    });

    document.addEventListener('shopify:block:select', function (event) {
        var group = closestGroup(event.target);
        if (!group) { return; }

        var root = group.closest ? group.closest(ROOT_SELECTOR) : null;
        if (!root || !root.hdComparisonTable) { return; }

        root.hdComparisonTable.openOnly(group);
    });
})();
